import {GET_SEO} from './type'

export function getSEO(pathname) {
    return (dispatch, getState, {axios}) => {
        return new Promise((resolve, reject) => {
            axios.post(`/seo/url`, {pathname})
            .then((response) => {
                dispatch({
                    type: GET_SEO,
                    payload: response.data
                })
                resolve(response.data);
            })
        })
    }
}